{
  "dashboard.greeting.morning": "早上好，{name}",
  "dashboard.greeting.afternoon": "下午好，{name}",
  "dashboard.greeting.evening": "晚上好，{name}",
  "dashboard.subtitle": "这是今天需要你关注的客户服务动态。",
  "dashboard.period.today": "今天",
  "dashboard.period.thisWeek": "本周",
  "dashboard.period.thisMonth": "本月",
  "dashboard.viewReports": "查看报表",
  "dashboard.queue.title": "队列健康",
  "dashboard.status.title": "未结工单构成",
  "dashboard.status.empty": "暂无未结工单",
  "dashboard.waiting.title": "等待最久的工单",
  "dashboard.waiting.description": "未响应的按创建至今计算，已响应的按最后更新至今计算。",
  "dashboard.waiting.search": "搜索主题、单号…",
  "dashboard.waiting.filter": "筛选工单",
  "dashboard.waiting.unansweredOnly": "仅看未响应",
  "dashboard.waiting.empty": "没有符合条件的工单",
  "dashboard.waiting.number": "工单号",
  "dashboard.waiting.subject": "主题",
  "dashboard.waiting.project": "项目",
  "dashboard.waiting.team": "客服组",
  "dashboard.waiting.assignee": "跟进人",
  "dashboard.waiting.status": "状态",
  "dashboard.waiting.waiting": "等待时长",
  "dashboard.waiting.awaitingFirstResponse": "未响应",
  "dashboard.trend.title": "近 14 天趋势",
  "dashboard.mine.title": "我的工作",
  "dashboard.mine.activeAssigned": "我的在手",
  "dashboard.mine.awaitingMyResponse": "待我响应",
  "dashboard.mine.resolvedToday": "我今日解决",
  "dashboard.mine.participating": "我参与的",
  "dashboard.updates.title": "最新动态",
  "dashboard.updates.search": "搜索动态",
  "dashboard.updates.empty": "没有匹配的动态",
  "dashboard.updates.action.statusChanged": "{actor} 把状态改为「{target}」",
  "dashboard.updates.action.assigned": "{actor} 指派给 {target}",
  "dashboard.updates.action.unassigned": "{actor} 取消了指派",
  "dashboard.updates.action.routed": "{actor} 路由到 {target}",
  "dashboard.updates.action.replied": "{actor} 回复了客户"
}
